// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2068":"e81be6e3","4392":"d2d4d246","5717":"a51848a9"}[chunkId] + ".chunk.css";
};